module.exports = __webpack_public_path__ + "img/zzfw.6a909522.png";